export var filterRedeemedOrExpired = function (certificateDetails) {
    return certificateDetails.filter(function (certificate) {
        return certificate.certificateAmount === '0.00' ||
            certificate.certificateStatus === 'EXPIRED';
    });
};
